import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/global';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  constructor(
    public global: Global,
  ) { }

  ngOnInit(): void {
  }

}
